/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseMessage } from "@vertical-insure/shared";

export default class FrameController {
  private element: HTMLIFrameElement;
  private iframeOrigin: string;

  constructor(element: HTMLIFrameElement, iframeOrigin: string) {
    this.element = element;
    this.iframeOrigin = iframeOrigin;
  }

  postMessage(eventType: string, payload?: any) {
    const message = { eventType: eventType, ...payload };
    this.element.contentWindow?.postMessage(message, this.iframeOrigin);
  }

  addMessageListener(callback: (event: MessageEvent<BaseMessage>) => void) {
    window.addEventListener('message', callback);
  }

  removeMessageListener(callback: (event: MessageEvent<BaseMessage>) => void) {
    window.removeEventListener('message', callback);
  }

  postMessageWithResponseListener(
    eventType: string,
    payload?: any
  ): Promise<any> {
    return new Promise((resolve) => {
      const responseListener = (event: MessageEvent<BaseMessage>) => {
        if (event.data.eventType !== eventType) return;
        window.removeEventListener('message', responseListener);
        resolve(event.data);
      };

      window.addEventListener('message', responseListener);
      this.postMessage(eventType, payload);
    });
  }
}